export class AccountModel {

  id: string;
  uid: number;
  name: string;
  number: string;
  type: string;
  palabrasClave: string;

  constructor() { }
}
